import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { Validator } from "../../snippets/Validator";

export class Repair extends CRUDEntity {

    #validationFields = [
        'repairs',
    ]

    constructor(id=null) {
        Object.assign(Repair.prototype, FormActions);
        Object.assign(Repair.prototype, EntityModalForm);
        super();
        this.entityClass = 'repair-list';
        this.urlRoot = '/vehicles-management/repair-list';
        this.sectionRootUrl = '/vehicles-management';
        this.id = id;
        Repair.prototype.delegatedListnersForButtons = function(type, entityClass) {
            $(`#${type}-${entityClass} #hints-open`).on('click', (ev)=>{
                let formHTML;
                $.ajax({
                    method: "GET",
                    url: `${this.urlRoot}/get-hints-form`,
                    async: false,
                    success: (response) => {
                        if (response.redirect) window.location = response.redirect;
                        else formHTML = response;
                    }
                });
                const formContainer = $(`#form-container`);
                formContainer.append(formHTML);
                $(`#modal-hints`).modal('show');
            })
            
            const validateCb = () => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)
            }
            for(let field of this.#validationFields){
                $(`#${type}-${entityClass} [name=${field}]`).on('change',validateCb)
            }
            if(type == 'edit')
                validateCb()

            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if(this.validationForm(type,true)){
                    if (type == 'edit') 
                        this.update(()=>setTimeout(() => window.location.reload(), 500));
                }
            });
        }
    }

    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const validator = new Validator({
            'repairs': ['required'],
        });
        let validateFlag = true;
        this.#validationFields.forEach(element => {
            if (validator.validate(element, data[element])) {
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','');
            }else{
                validateFlag = false;
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','border:2px solid #DB3A57 !important;');
            }
        });
        return validateFlag;
    }
}